<template>
  <div class="m-b-lg">
    <div
      v-if="$route.query.incomplete !== 'true'"
      class="border-bottom p-t-md p-b-md"
    >
      <div class="container">
        <a
          @click.prevent="$router.go(-1)"
        >
          <i
            class="fas fa-arrow-circle-left"
            aria-hidden="true"
          />
          Go back
        </a>
      </div>
    </div>
    <div class="container">
      <div class="columns is-centered m-t-md">
        <div class="column is-half">
          <div class="p-md box">
            <div class="content">
              <h2
                class="has-text-centered"
                v-text="$wording.profile.title_1"
              />
              <p>
                This account provides access to manage lead disclosures and certifications for your properties. This is a requirement of the <a
                  href="https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-191265"
                  target="_blank"
                >Philadelphia Lead Paint Disclosure and Certification Law <i class="fas fa-external-link" /></a>.
              </p>
            </div>
            <profile-form
              :user="user"
              screen="profile"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileForm from '@/components/ProfileForm';
export default {
  name: 'Profile',
  components: {
    ProfileForm,
  },
  computed: {
    user() {
      return this.$store.state.users.me;
    },
  },
  async beforeMount() {
    return await this.$store.dispatch('users/getMe');
  },
};
</script>

<style lang="scss" scoped>
</style>